const module = 'klevu-quick-search'

const dataAttributes = {
  tabsWrapper: `[data-el="${module}.tabWrapper`,
  tabHeaders: `[data-el="${module}.tabHeader`,
}

const checkIfTabsExist = () => {
  const mutationTarget = document
  const options = {
    childList: true,
    subtree: true,
  }

  const observer = new MutationObserver(mCallback)
  function mCallback (mutations) {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        const tabHeaders = node.querySelectorAll(dataAttributes.tabHeaders)
        if (tabHeaders.length) {
          addEventListeners()
          observer.disconnect()
        }
      })
    }
  }

  observer.observe(mutationTarget, options)
}

const initialise = () => {
  const searchInput = document.querySelector('.hd-MobileSearch_Input')

  searchInput.addEventListener('keyup', () => {
    checkIfTabsExist()
  })
}

const addEventListeners = () => {
  const tabHeaders = document.querySelectorAll(dataAttributes.tabHeaders)

  tabHeaders.forEach(heading => {
    heading.addEventListener('click', event => {
      toggleTabs(event)
    })
  })
}

const toggleTabs = event => {
  const allTabWrappers = document.querySelectorAll(dataAttributes.tabsWrapper)
  allTabWrappers.forEach(wrapper => {
    wrapper.setAttribute('aria-expanded', 'false')
  })

  const activeTabWrapper = event.target.closest(dataAttributes.tabsWrapper)
  activeTabWrapper.setAttribute('aria-expanded', 'true')
}

initialise()
